export default __webpack_public_path__ + "6f047ed30de52144f84b1946820010c7.png";